import { stringify } from 'qs';

import { IGetSuburbanValuationFormUrlProps, IGetValuationFormUrlProps } from './types';
import { trackCalculateClick } from '../../analytics';
import { mapEstimationTargetToCategory } from '../../constants/filters';
import { TThunkAction } from '../../types/redux';
import { navigateToPage } from '../../utils/navigateToPage';

interface IParams {
  pushNeed?: boolean;
}

export const openDataPaymentForm = ({ pushNeed }: IParams = {}): TThunkAction => {
  return (dispatch, getState) => {
    const { page, filters } = getState();
    const { estimationTarget, houseId } = filters;

    const formParams: IGetValuationFormUrlProps = {
      address: filters.address,
      houseId: filters.houseId,
      roomsCount: filters.roomsCount,
      totalArea: filters.area,
      pushNeed: pushNeed ? 1 : null,
    };
    const queryString = stringify(formParams, { skipNulls: true });

    trackCalculateClick({
      page,
      queryString,
      estimationTarget,
      houseId,
      address: filters.address,
      area: filters.area,
      roomsCount: filters.roomsCount,
      pushEnabled: filters.pushEnabled,
      pushNotificationsAllowed: page.pushNotificationsAllowed,
    });

    navigateToPage(`/valuation-form/?${queryString}`);
  };
};

export const openSuburbanDataPaymentForm = ({ pushNeed }: IParams = {}): TThunkAction => {
  return (dispatch, getState) => {
    const { page, filters } = getState();
    const { estimationTarget, houseId } = filters;

    const formParams: IGetSuburbanValuationFormUrlProps = {
      address: filters.address,
      houseId: filters.houseId,
      houseArea: filters.houseArea,
      landArea: filters.landArea as number,
      category: mapEstimationTargetToCategory[estimationTarget],
      pushNeed: pushNeed ? 1 : null,
    };
    const queryString = stringify(formParams, { skipNulls: true });

    trackCalculateClick({
      page,
      queryString,
      estimationTarget,
      houseId,
      address: filters.address,
      houseArea: filters.houseArea,
      landArea: filters.landArea,
      pushNotificationsAllowed: page.pushNotificationsAllowed,
    });

    navigateToPage(`/valuation-form/?${queryString}`);
  };
};
